import React from 'react';
import styled from 'styled-components';
import { Modal, Text } from 'components';
import { ModalFuncProps } from 'antd';
import { makeModalResponsive } from 'utils';
import { TourItemContent } from '../types';
import TimeNoLongerAvailableItem from './TimeNoLongerAvailableItem';

interface TimeNoLongerAvailableModalProps {
  unavailableTourItems: TourItemContent[];
  isWithoutCoords?: boolean;
}

const TimeNoLongerAvailableModal: React.FC<TimeNoLongerAvailableModalProps> = ({
  unavailableTourItems,
  isWithoutCoords,
}) => (
    <>
      <StyledText type="secondary">
        One or more of the times you have selected{' '}
        {isWithoutCoords
          ? 'have invalid coordinates'
          : 'are no longer available'}
      </StyledText>
      <StyledItemsContainer>
        {unavailableTourItems.map(item => (
          <TimeNoLongerAvailableItem
            item={item}
            key={item.id}
            isWithoutCoords={isWithoutCoords}
          />
        ))}
      </StyledItemsContainer>
    </>
  );

const showItemsWithoutCoordinatesModal = (
  itemsWithoutCoordinates: TourItemContent[],
) => {
  makeModalResponsive(
    Modal.info({
      title: 'Some of the listings in the tour cannot be displayed in the map.',
      content: (
        <TimeNoLongerAvailableModal
          unavailableTourItems={itemsWithoutCoordinates}
          isWithoutCoords
        />
      ),
      centered: true,
      getContainer: document.getElementById('tour-edit-page-root'),
    }),
    { dataCys: { content: 'items-cannot-display-modal' } },
  );
};

const showTimeNoLongerAvailableModal = ({
  itemsWithUnavailableTime,
  itemsWithoutCoords,
}: {
  itemsWithUnavailableTime: TourItemContent[];
  itemsWithoutCoords: TourItemContent[];
}) => {
  if (!itemsWithUnavailableTime.length) {
    // Meaning only itemsWithoutCoords.length > 0
    showItemsWithoutCoordinatesModal(itemsWithoutCoords);
    return;
  }
  const modalProps: ModalFuncProps = {
    title: 'Please select a new time for the following listings',
    content: (
      <TimeNoLongerAvailableModal
        unavailableTourItems={itemsWithUnavailableTime}
      />
    ),
    centered: true,
    getContainer: document.getElementById('tour-edit-page-root'),
  };
  if (itemsWithoutCoords.length) {
    modalProps.onOk = () => {
      showItemsWithoutCoordinatesModal(itemsWithoutCoords);
    };
  }
  makeModalResponsive(Modal.info(modalProps), {
    dataCys: { content: 'time-unavailable-modal' },
  });
};

export default showTimeNoLongerAvailableModal;

const StyledText = styled(Text)`
  display: flex;
  margin-bottom: 9px;
`;

const StyledItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
`;
